import React from "react";
import Banner from "../../components/Banner/Banner";
import Gallery from "../../components/Gallery/Gallery";

export default function Home() {
  return (
    <>
      <Banner page="home" />   {/* props permettant d'adapter la bannière*/}
      <Gallery />
    </>
  );
}
